import React, {useEffect, useState} from 'react'
import FileUpload from "../../../FileUploads/FileUpload";
import {toast} from "react-toastify";
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";

const Type = ({
                  stagesId,
                  formData = [],
                  handleInput = () => {},
                  documentUploadUrlPublic,
                  documentUrlDataPublic,
                  LastLeadOpportunityActivity=[],
                  inputList,
                  opportunityDetails=[],
                  activityId='',
                  senior=[],
                  selectedTaggedAlongResponse=[],
                  setTaggedAlonedReportee = () => {}
              }) => {

    const [solutionType, setSolutionType] = useState([{id: '', selected:false}])
    const [serviceType, setServiceType] = useState([{id: '', selected:false}])
    const [isParkingSlot, setIsParkingSlot] = useState(false)
    const [isParkingValetSlot, setIsParkingValetSlot] = useState(false)
    const [isValetSlot, setIsValetSlot] = useState(false)
    const [noOfSlot, setNoOfSlot] = useState(0)
    const [noOfDriver, setNoOfDriver] = useState(0)
    const [kdm, setKdm] = useState([{name: '', contact_no:'', email_id:''}])
    const [poc, setPoc] = useState([{name: '', contact_no:'', email_id:''}])
    const [wordsUsed, setWordsUsed] = useState(0)
    const [opportunityTye, setOpportunityType] = useState('')
    const [product, setProduct] = useState([{name:''}])
    const [deleteKdmIds, setDeletedKdmIds] = useState([])
    const [deletePOCIds, setDeletedPOCIds] = useState([])
    const [gates, setGates] = useState([{name:'', count: ''}])
    const [tags, setTags] = useState([{name:'', count: '', price:''}])

    useEffect(() => {
        if(opportunityDetails?.opportunity_type_id !== undefined){
            setOpportunityType(opportunityDetails?.opportunity_type_id)
        }
    }, [opportunityDetails])

    useEffect(() => {
        if(LastLeadOpportunityActivity?.meta_data !== undefined && LastLeadOpportunityActivity?.meta_data !== null
            && LastLeadOpportunityActivity?.meta_data[0] !== undefined){
            if(LastLeadOpportunityActivity?.meta_data[0]?.solution_details !== undefined){
                setSolutionType(LastLeadOpportunityActivity?.meta_data[0]?.solution_details)
            }

            if(LastLeadOpportunityActivity?.meta_data[0]?.service_details !== undefined){
                setServiceType(LastLeadOpportunityActivity?.meta_data[0]?.service_details)
            }

            if(LastLeadOpportunityActivity?.meta_data[0]?.no_of_slots !== undefined){
                setNoOfSlot(LastLeadOpportunityActivity?.meta_data[0]?.no_of_slots)
            }

            if(LastLeadOpportunityActivity?.meta_data[0]?.no_of_drivers !== undefined){
                setNoOfDriver(LastLeadOpportunityActivity?.meta_data[0]?.no_of_drivers)
            }

            if(LastLeadOpportunityActivity?.meta_data[0]?.product !== undefined){
                setProduct(LastLeadOpportunityActivity?.meta_data[0]?.product)
            }

            if(LastLeadOpportunityActivity?.kdm.length > 0){
                setKdm(LastLeadOpportunityActivity?.kdm)
            }
            if(LastLeadOpportunityActivity?.lead_poc.length > 0){
                setPoc(LastLeadOpportunityActivity?.lead_poc)
            }
            if(LastLeadOpportunityActivity?.meta_data[0]?.MOM !== undefined){
                delete LastLeadOpportunityActivity?.meta_data[0]?.MOM
            }

            if(parseInt(activityId) === 35 && LastLeadOpportunityActivity?.meta_data[0]?.Gate_Count !== undefined){
                delete LastLeadOpportunityActivity?.meta_data[0]?.Gate_Count
            }

            handleInput('meta_data', LastLeadOpportunityActivity?.meta_data[0])
        }
    }, [LastLeadOpportunityActivity])

    useEffect(() => {
        setIsParkingSlot(false)
        setIsParkingValetSlot(false)
        setIsValetSlot(false)
        serviceType.map(val => {
            if(val?.id === 'Parking Slots + Valet'){
                setIsParkingValetSlot(true)
            } else if(val?.id === 'Parking Slots'){
                setIsParkingSlot(true)
            } else if(val?.id === 'Valet Services'){
                setIsValetSlot(true)
            }
        })

    }, [serviceType])

    useEffect(() => {
        if(!isParkingSlot && inputList[0]['meta_data']?.no_of_slots !== undefined){
            delete inputList[0]['meta_data']['no_of_slots']
        }

        if(!isValetSlot && inputList[0]['meta_data']?.no_of_drivers !== undefined){
            console.log("opportunity")
            delete inputList[0]['meta_data']['no_of_drivers']
        }
    }, [isParkingSlot, isValetSlot])

    const handleProductType = () => {
        setProduct([
            ...product,
            {name: ''}
        ])
    }

    const handleRemoveProductType = (e, index) => {
        const list = [...product]
        list.splice(index, 1);
        setProduct(list);
        e.preventDefault()
    }

    const handleProductInput = (index, val) => {
        let isDuplicate = false
        let list = [...product]
        product.map(value => {
            if(value?.name === val){
                isDuplicate = true
            }
        })
        if(isDuplicate){
            setTimeout(() => {
                list.splice(list.length-1, 1)
                setProduct(list)
                toast.warning(val+" Product already selected.")
            }, 200)
            return false
        }
        list[index]['name'] = val
        setProduct(list)
        handleInput('meta_data', product,  'product')
    }

    const handleAddSolutionType = () => {
        setSolutionType([
            ...solutionType,
            {id: ''}
        ])
    }

    const handleRemoveSolutionType = (e, index) => {
        const list = [...solutionType]
        list.splice(index, 1);
        if(list[0] !== undefined && list[0]['id'] !== undefined && list[0]['id'] !== ''){
            handleInput('meta_data', list, 'solution_details')
        }
        setSolutionType(list);
        e.preventDefault()
    }

    const handleSolutionInput = (index, val) => {
        let isDuplicate = false
        let list = [...solutionType]
        solutionType.map(value => {
            if(value?.id === val){
                isDuplicate = true
            }
        })
        if(isDuplicate){
            setTimeout(() => {
                list.splice(list.length-1, 1)
                setSolutionType(list)
                toast.warning(val+" Solution already selected.")
            }, 200)
            return false
        }
        list[index]['id'] = val
        list[index]['selected'] = true
        setSolutionType(list)
        handleInput('meta_data', solutionType,  'solution_details')
    }

    const handleRemoveKDM = (e, index, id) => {
        const list = [...kdm]
        list.splice(index, 1);
        setKdm(list);
        if(id !== undefined){
            deleteKdmIds.push(id)
        }
        handleInput('delete_kdm_ids', deleteKdmIds)
        handleInput('kdm_details', list)
        e.preventDefault()
    }

    const handlePOCInput = (index, key, val) => {
        let list = [...poc]
        if(key === 'contact_no' && val[0] === '0'){
            toast.warning("Contact no can't be start with zero")
            return false
        }
        let isDuplicate = false
        poc.map(value => {
            if(value?.contact_no === val){
                isDuplicate = true
            }
            // if(value?.email_id === val){
            //     isDuplicate = true
            // }
        })
        if(isDuplicate){
            list[index][key] = ""
            setPoc(list)
            setTimeout(() => {
                toast.warning(val+" already exist.")
            }, 200)
            return false
        }

        kdm.map(value => {
            if(value?.contact_no === val){
                isDuplicate = true
            }
            // if(value?.email_id === val){
            //     isDuplicate = true
            // }
        })
        if(isDuplicate){
            list[index][key] = ""
            setPoc(list)
            setTimeout(() => {
                toast.warning(val+" already exist in KDM.")
            }, 200)
            return false
        }

        list[index][key] = val
        setPoc(list)
        handleInput('poc', poc)
    }

    const handleAddPOC = () => {
        setPoc([
            ...poc,
            {name: '', contact_no:'', email_id:''}
        ])
    }

    const handleRemovePOC = (e, index, id='') => {
        const list = [...poc]
        list.splice(index, 1);
        setPoc(list);
        if(id !== undefined){
            deletePOCIds.push(id)
        }
        handleInput('delete_poc_ids', deletePOCIds)
        handleInput('poc', list)
        e.preventDefault()
    }

    const handleKDMInput = (index, key, val) => {
        let list = [...kdm]
        if(key === 'contact_no' && val[0] === '0'){
            toast.warning("Contact no can't be start with zero")
            return false
        }

        let isDuplicate = false
        kdm.map(value => {
            if(value?.contact_no === val){
                isDuplicate = true
            }
            // if(value?.email_id === val){
            //     isDuplicate = true
            // }
        })
        if(isDuplicate){
            list[index][key] = ""
            setKdm(list)
            setTimeout(() => {
                toast.warning(val+" already exist.")
            }, 200)
            return false
        }
        isDuplicate = false
        poc.map(value => {
            if(value?.contact_no === val){
                isDuplicate = true
            }
            // if(value?.email_id === val){
            //     isDuplicate = true
            // }
        })
        if(isDuplicate){
            list[index][key] = ""
            setKdm(list)
            setTimeout(() => {
                toast.warning(val+" already exist in POC.")
            }, 200)
            return false
        }

        list[index][key] = val
        setKdm(list)
        handleInput('kdm_details', kdm)
    }

    const handleAddKDM = () => {
        setKdm([
            ...kdm,
            {name: '', contact_no:'', email_id:''}
        ])
    }

    const handleAddServiceType = () => {
        setServiceType([
            ...serviceType,
            {id: ''}
        ])
    }

    const handleRemoveServiceType = (e, index) => {
        const list = [...serviceType]
        list.splice(index, 1);
        if(list[0] !== undefined && list[0]['id'] !== undefined && list[0]['id'] !== ''){
            handleInput('meta_data', list, 'service_details')
        }
        setServiceType(list);
        e.preventDefault()
    }

    const handleServiceInput = (index, val) => {
        let list = [...serviceType]
        let isDuplicate = false
        serviceType.map(value => {
            if(value?.id === val){
                isDuplicate = true
            }
        })
        if(isDuplicate){
            setTimeout(() => {
                list.splice(list.length-1, 1)
                setServiceType(list)
                toast.warning(val+" Service already selected.")
            }, 200)
            return false
        }

        list[index]['id'] = val
        list[index]['selected'] = true
        setServiceType(list)
        handleInput('meta_data', serviceType, 'service_details')
    }

    const handleWordUsed = (value) => {
        setWordsUsed(value.split(" ").length-1)
    }

    const handleAddGate = () => {
        setGates([
            ...gates,
            {name: '', count:''}
        ])
    }

    const handleRemoveGates = (e, index) => {
        const list = [...gates]
        list.splice(index, 1);
        setGates(list);
        e.preventDefault()
    }

    const handleGatesInput = (index, val, key) => {
        let isDuplicate = false
        let list = [...gates]
        gates.map(value => {
            if(value?.name === val){
                isDuplicate = true
            }
        })
        if(isDuplicate){
            setTimeout(() => {
                list.splice(list.length-1, 1)
                setGates(list)
                toast.warning(val+" Gates already selected.")
            }, 200)
            return false
        }

        if(key === 'count' && (val <=0 || val >= 100)){
            setTimeout(() => {
                list[index][key] = ''
                setGates(list)
                toast.warning("Gate must be in 0 to 99")
            }, 200)
            return false
        }
        list[index][key] = val
        setGates(list)
        handleInput('meta_data', gates,  'Gates')
    }

    const handleAddTages = () => {
        setTags([
            ...tags,
            {name: '', count:'', price:''}
        ])
    }

    const handleRemoveTags = (e, index) => {
        const list = [...tags]
        list.splice(index, 1);
        setTags(list);
        e.preventDefault()
    }

    const handleTagsInput = (index, val, key) => {
        let isDuplicate = false
        let list = [...tags]
        tags.map(value => {
            if(value?.name === val){
                isDuplicate = true
            }
        })
        if(isDuplicate){
            setTimeout(() => {
                list.splice(list.length-1, 1)
                setTags(list)
                toast.warning(val+" already selected.")
            }, 200)
            return false
        }
        list[index][key] = val
        setTags(list)
        handleInput('meta_data', tags,  'tags')
    }
    return (
        <>
            {(parseInt(opportunityTye) === 96) &&
                    <>
                        <div className="col-md-6 float-field ">
                            <input type="date"
                                   className="form-control form-control-user"
                                   placeholder=" "
                                   onChange={(e) => {handleInput('meta_data', e.target.value, 'Expected_Payment_Date')}}
                                   value={inputList[0]?.meta_data?.Expected_Payment_Date}
                                   required
                            />
                            <label className="large-label float-lb">
                                Expected Payment Date<i className="bi bi-asterisk astrick-icon"></i>
                            </label>
                        </div>
                        <div className="col-md-6 float-field ">
                            <input type="number"
                                   className="form-control form-control-user"
                                   placeholder=" "
                                   onChange={(e) => {handleInput('meta_data', e.target.value, 'Amount')}}
                                   value={inputList[0]?.meta_data?.Amount}
                                   required
                            />
                            <label className="large-label float-lb">
                                Amount<i className="bi bi-asterisk astrick-icon"></i>
                            </label>
                        </div>
                    <div className="col-sm-6 mt-1 float-field mb-3">
                        <div className="userWords" style={{color:"cornflowerblue", left:"6px"}}>
                            Total used Word {wordsUsed}
                        </div>
                        <textarea
                            className="form-control form-control-user"
                            placeholder="MOM"
                            onChange={(e) => {
                                handleInput('meta_data',  e.target.value,'MOM', e)
                                handleWordUsed(e.target.value)
                            }}
                            required={true}
                            rows="4" cols="50"
                        />
                    </div>
                    </>
            }
            {(parseInt(opportunityTye) === 95) &&
                <>
                    <div className="col-sm-6 mt-1 float-field mb-3">
                        <div className="userWords" style={{color:"cornflowerblue", left:"6px"}}>
                            Total used Word {wordsUsed}
                        </div>
                        <textarea
                            className="form-control form-control-user"
                            placeholder="MOM"
                            onChange={(e) => {
                                handleInput('meta_data',  e.target.value,'MOM', e)
                                handleWordUsed(e.target.value)
                            }}
                            required={true}
                            rows="4" cols="50"
                        />
                    </div>
                </>
            }
            {formData?.staged_question_mapping !== undefined &&
            formData?.staged_question_mapping[stagesId] !== undefined &&
            formData?.staged_question_mapping[stagesId].map((val, i) => {
                return (
                    <>
                        {val.type === 'n1' &&
                            <div className="col-md-6 float-field ">
                                <input type="number"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {handleInput('meta_data', e.target.value, 'no_of_gates')}}
                                       value={inputList[0]?.meta_data?.no_of_gates}
                                       required
                                />
                                <label className="large-label float-lb">
                                    No of Gates <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        }

                        {val.type === 'n2' &&
                            <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                <input type="date"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {
                                           handleInput('meta_data',e.target.value,"follow_up",  e)
                                       }}
                                       id="validationCustom01"
                                       required={true}
                                       min={new Date().toISOString().split('T')[0]}
                                />
                                <label className="large-label float-lb">
                                    Follow up required <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        }
                        {val.type === 'n3' &&
                            <div className="col-sm-6 mt-1 float-field mb-3">
                                <textarea
                                    className="form-control form-control-user"
                                    placeholder="Introduction"
                                    onChange={(e) => {
                                        handleInput('meta_data',  e.target.value,'Introduction', e)
                                    }}
                                    required={true}
                                    rows="4" cols="50"
                                />
                            </div>
                        }
                        {val.type === 'n20' &&
                            <div className="col-md-6 float-field ">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {handleInput('meta_data', e.target.value, 'Gate_Count')}}
                                       value={inputList[0]?.meta_data?.Gate_Count}
                                       required
                                />
                                <label className="large-label float-lb">
                                    Gate Count <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        }
                        {val.type === 'n4' &&
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                            <h1 className="h3 mb-0 text-black-100"><b>Gate Details</b></h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    {gates.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {handleGatesInput(i, e.target.value, 'name')}}
                                                                        required={true}
                                                                    >
                                                                        <option value="">Select Type of Gates</option>
                                                                        <option value="Full Gate">Full Gate</option>
                                                                        <option value="Integration Gate">Integration Gate</option>
                                                                        <option value="Visitor Gate">Visitor Gate</option>
                                                                        <option value="Integration Gate">Integration Gate</option>
                                                                        <option value="Pure AMC">Pure AMC</option>
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Type of Gates <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {handleGatesInput(i, e.target.value, 'count')}}
                                                                           value={val?.count}
                                                                           required
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Gate Count <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                                    {gates.length !== 1 &&
                                                                        <button
                                                                            onClick={(e) => handleRemoveGates(e, i)}
                                                                            className="btn btn-sm btn-danger ml-3">Gate Remove
                                                                        </button>
                                                                    }
                                                                    {gates.length - 1 === i &&
                                                                        <button
                                                                            className="btn btn-sm btn-primary ml-3"
                                                                            onClick={(e) => handleAddGate()}>Gate Add
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                            <h1 className="h3 mb-0 text-black-100"><b>Tags</b></h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    {tags.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {handleTagsInput(i, e.target.value, 'name')}}
                                                                        required={true}
                                                                    >
                                                                        <option value="">Select Type of Tags</option>
                                                                        <option value="Windshield Tags">Windshield Tags</option>
                                                                        <option value="Two wheeler Tags">Two wheeler Tags</option>
                                                                        <option value="Fitkt Tags">Fitkt Tags</option>
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Type of Tags <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="number"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {handleTagsInput(i, e.target.value, 'count')}}
                                                                           required
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Tag Qty <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="number"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {handleTagsInput(i, e.target.value, 'price')}}
                                                                           required
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Price <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                                    {tags.length !== 1 &&
                                                                        <button
                                                                            onClick={(e) => handleRemoveTags(e, i)}
                                                                            className="btn btn-sm btn-danger ml-3">Tag Remove
                                                                        </button>
                                                                    }
                                                                    {tags.length - 1 === i &&
                                                                        <button
                                                                            className="btn btn-sm btn-primary ml-3"
                                                                            onClick={(e) => handleAddTages()}>Tag Add
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 mtk-1 float-field mb-3" key={i}>
                                    <FileUpload
                                        id={`addAttachment`}
                                        accept=".png,.jpg,.jpeg"
                                        documentUploadUrl={documentUploadUrlPublic}
                                        documentUrlData={documentUrlDataPublic}
                                        onChange={(e, val) => {
                                            handleInput('meta_data', e, 'Agreement_and_cheque_picked_doc',e)
                                        }}
                                        prefilledFilename={""}
                                        multiple={true}
                                    >
                                        Agreement and cheque picked
                                    </FileUpload>
                                </div>
                            </>
                        }
                        {val.type === 'n7' &&
                            <>

                                <div className="col-sm-6 mt-1 float-field mb-3">
                                    <div className="userWords" style={{color:"cornflowerblue", left:"6px"}}>
                                        Total used Word {wordsUsed}
                                    </div>
                                <textarea
                                    className="form-control form-control-user"
                                    placeholder="MOM"
                                    onChange={(e) => {
                                        handleInput('meta_data',  e.target.value,'MOM', e)
                                        handleWordUsed(e.target.value)
                                    }}
                                    required={true}
                                    rows="4" cols="50"
                                />
                                </div>
                            </>
                        }
                        {val?.type === 'n8' &&
                            <>
                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                    <input type="date"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput('meta_data',e.target.value,'future_activity_date',  e)
                                           }}
                                           id="validationCustom01"
                                           required={true}
                                           min={new Date().toISOString().split('T')[0]}
                                    />
                                    <label className="large-label float-lb">
                                        Future Activity Date <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            </>
                        }
                        {val?.type === 'n9' &&
                            <>
                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                    <input type="date"
                                           className="form-control form-control-user"
                                           placeholder=" "
                                           onChange={(e) => {
                                               handleInput('meta_data',e.target.value,'Follow_up_Date',  e)
                                           }}
                                           id="validationCustom01"
                                           required={true}
                                           min={new Date().toISOString().split('T')[0]}
                                    />
                                    <label className="large-label float-lb">
                                        Follow up Date <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            </>
                        }
                        {val?.type === 'n5' &&
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                            <h1 className="h3 mb-0 text-black-100"><b>KDM Details</b></h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    {kdm.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleKDMInput(i, 'name', e.target.value)
                                                                           }}
                                                                           required={parseInt(activityId) !== 32}
                                                                           value={val?.name}

                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Name
                                                                        {parseInt(activityId) !== 32 &&
                                                                            <i className="bi bi-asterisk astrick-icon"></i>
                                                                        }
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="number"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleKDMInput(i, 'contact_no', e.target.value)
                                                                           }}
                                                                           required={parseInt(activityId) !== 32}
                                                                           value={val?.contact_no}
                                                                           onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Contact No
                                                                        {parseInt(activityId) !== 32 &&
                                                                            <i className="bi bi-asterisk astrick-icon"></i>
                                                                        }
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="email"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handleKDMInput(i, 'email_id', e.target.value)
                                                                           }}
                                                                           required={parseInt(activityId) !== 32}
                                                                           value={val?.email_id}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Email
                                                                        {parseInt(activityId) !== 32 &&
                                                                            <i className="bi bi-asterisk astrick-icon"></i>
                                                                        }

                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                                    {kdm.length !== 1 &&
                                                                        <button
                                                                            onClick={(e) => handleRemoveKDM(e, i, val?.id)}
                                                                            className="btn btn-sm btn-danger ml-3">KDM Remove
                                                                        </button>
                                                                    }
                                                                    {kdm.length - 1 === i &&
                                                                        <button
                                                                            className="btn btn-sm btn-primary ml-3"
                                                                            onClick={(e) => handleAddKDM()}>KDM Add
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                        {val?.type === 'n6' &&
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div
                                            className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                            <h1 className="h3 mb-0 text-black-100"><b>POC Details</b></h1>
                                        </div>
                                        <div className="card-body bg-white">
                                            <div className="user">
                                                <div className="form-group row">
                                                    {poc.map((val, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handlePOCInput(i, 'name', e.target.value)
                                                                           }}
                                                                           required
                                                                           value={val?.name}

                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Name<i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="number"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handlePOCInput(i, 'contact_no', e.target.value)
                                                                           }}
                                                                           required
                                                                           value={val?.contact_no}
                                                                           onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Contact No  <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div className="col-md-6 float-field ">
                                                                    <input type="email"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           onChange={(e) => {
                                                                               handlePOCInput(i, 'email_id', e.target.value)
                                                                           }}
                                                                           required
                                                                           value={val?.email_id}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Email  <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                                    {poc.length !== 1 &&
                                                                        <button
                                                                            onClick={(e) => handleRemovePOC(e, i, val?.id)}
                                                                            className="btn btn-sm btn-danger ml-3">Remove
                                                                        </button>
                                                                    }
                                                                    {poc.length - 1 === i &&
                                                                        <button
                                                                            className="btn btn-sm btn-primary ml-3"
                                                                            onClick={(e) => handleAddPOC()}>Add
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {val?.type === 'n19' &&
                            <>
                                {
                                    product.map((value, i) => {
                                        return (
                                            <>
                                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                    <select
                                                        className="form-control form-control-user"
                                                        onChange={(e) => {
                                                            handleProductInput(i, e.target.value)
                                                        }} required={true}>
                                                        <option value="">Select Service
                                                        </option>
                                                        {formData?.solution_services !== undefined && formData?.solution_services?.products !== undefined &&
                                                            formData?.solution_services?.products.length > 0 && formData?.solution_services?.products.map((val) => {
                                                                return (
                                                                    <>
                                                                        {value?.name === val?.id ?
                                                                            <option value={val?.id} selected>{val.name}</option>
                                                                            :
                                                                            <option value={val?.id} >{val.name}</option>
                                                                        }
                                                                    </>
                                                                )
                                                            })}
                                                    </select>
                                                    <label className="large-label float-lb">
                                                        Product <i className="bi bi-asterisk astrick-icon"></i>
                                                    </label>
                                                </div>

                                                <div
                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                    {product.length !== 1 &&
                                                        <button
                                                            onClick={(e) => handleRemoveProductType(e, i)}
                                                            className="btn btn-sm btn-danger ml-3">Remove
                                                        </button>
                                                    }
                                                    {product.length - 1 === i &&
                                                        <button
                                                            className="btn btn-sm btn-primary ml-3"
                                                            onClick={(e) => handleProductType()}>Add
                                                        </button>
                                                    }
                                                </div>

                                                {product[i].name === 'Services' &&
                                                    serviceType.map((value, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {
                                                                            handleServiceInput(i, e.target.value)
                                                                        }} required={true}>
                                                                        <option value="">Select Service
                                                                        </option>
                                                                        {formData?.solution_services !== undefined && formData?.solution_services?.services !== undefined &&
                                                                            formData?.solution_services?.services.length > 0 && formData?.solution_services?.services.map((val) => {
                                                                                return (
                                                                                    <>
                                                                                        {value?.id === val?.id ?
                                                                                            <option value={val?.id} selected>{val.name}</option>
                                                                                            :
                                                                                            <option value={val?.id} >{val.name}</option>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Services <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>

                                                                <div
                                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                                    {serviceType.length !== 1 &&
                                                                        <button
                                                                            onClick={(e) => handleRemoveServiceType(e, i)}
                                                                            className="btn btn-sm btn-danger ml-3">Service Remove
                                                                        </button>
                                                                    }
                                                                    {serviceType.length - 1 === i &&
                                                                        <button
                                                                            className="btn btn-sm btn-primary ml-3"
                                                                            onClick={(e) => handleAddServiceType()}>Service Add
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {product[i].name === 'Services' && (isValetSlot || isParkingValetSlot) &&
                                                    <div className="col-md-6 float-field ">
                                                        <input type="number"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   handleInput('meta_data', e.target.value, 'no_of_drivers')
                                                               }}
                                                               required
                                                               value={inputList[0]?.meta_data?.no_of_drivers}
                                                        />
                                                        <label className="large-label float-lb">
                                                            No.of Drivers <i className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                }
                                                { product[i].name === 'Services' && (isParkingSlot || isParkingValetSlot) &&
                                                    <div className="col-md-6 float-field ">
                                                        <input type="number"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               onChange={(e) => {
                                                                   handleInput('meta_data', e.target.value, 'no_of_slots')
                                                                   setNoOfSlot(e.target.value)
                                                               }}
                                                               required
                                                               value={noOfSlot}
                                                        />
                                                        <label className="large-label float-lb">
                                                            No. of Slots <i className="bi bi-asterisk astrick-icon"></i>
                                                        </label>
                                                    </div>
                                                }
                                                {product[i].name === 'Solution' &&
                                                    solutionType.map((value, i) => {
                                                        return (
                                                            <>
                                                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                                                    <select
                                                                        className="form-control form-control-user"
                                                                        onChange={(e) => {
                                                                            handleSolutionInput(i, e.target.value)
                                                                        }} required={true}>
                                                                        <option value="">Select Solution
                                                                        </option>
                                                                        {formData?.solution_services !== undefined && formData?.solution_services?.solutions !== undefined &&
                                                                            formData?.solution_services?.solutions.length > 0 && formData?.solution_services?.solutions.map((val) => {
                                                                                return (
                                                                                    <>
                                                                                        {value?.id === val?.id ?
                                                                                            <option value={val?.id} selected>{val.name}</option>
                                                                                            :
                                                                                            <option value={val?.id} >{val.name}</option>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })}
                                                                    </select>
                                                                    <label className="large-label float-lb">
                                                                        Solution <i className="bi bi-asterisk astrick-icon"></i>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    className="btn-box mb-4" style={{"width": "100%"}}>
                                                                    {solutionType.length !== 1 &&
                                                                        <button
                                                                            onClick={(e) => handleRemoveSolutionType(e, i)}
                                                                            className="btn btn-sm btn-danger ml-3">Solution Remove
                                                                        </button>
                                                                    }
                                                                    {solutionType.length - 1 === i &&
                                                                        <button
                                                                            className="btn btn-sm btn-primary ml-3"
                                                                            onClick={(e) => handleAddSolutionType()}>Solution Add
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </>
                                                        )
                                                    })
                                                }
                                                {product[i].name === 'Solution' &&
                                                    <>
                                                        <div className="col-md-6 float-field ">
                                                            <input type="number"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput('meta_data',  e.target.value, 'no_of_lanes')
                                                                   }}
                                                                   required
                                                                   value={inputList[0]?.meta_data?.no_of_lanes}

                                                            />
                                                            <label className="large-label float-lb">
                                                                No. of Lanes <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                        <div className="col-md-6 float-field ">
                                                            <input type="number"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput('meta_data', e.target.value, 'business_value')
                                                                   }}
                                                                   required
                                                                   value={inputList[0]?.meta_data?.business_value}
                                                            />
                                                            <label className="large-label float-lb">
                                                                Business Value <i className="bi bi-asterisk astrick-icon"></i>
                                                            </label>
                                                        </div>
                                                    </>
                                                }
                                            </>
                                        )
                                    })
                                }
                            </>
                        }

                        {val.type === 'n12' &&
                            <>
                                <div className="col-sm-6 mt-1 float-field mb-3">
                                <textarea
                                    className="form-control form-control-user"
                                    placeholder={val?.title}
                                    onChange={(e) => {
                                        handleInput('meta_data',  e.target.value,val?.title.replaceAll(" ", '_'), e)
                                    }}
                                    required={true}
                                    rows="4" cols="50"
                                />
                                </div>
                            </>
                        }
                        {val?.type === 'n13' &&
                            <div className="col-sm-6 mtk-1 float-field mb-3" key={i}>
                                <FileUpload
                                    id={`addAttachment`}
                                    accept=".png,.jpg,.jpeg"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(e, val) => {
                                        handleInput('meta_data', e, 'Document',e)
                                    }}
                                    prefilledFilename={""}
                                    multiple={true}
                                >
                                    File Attachment
                                </FileUpload>
                            </div>
                        }
                        {val?.type === 'n14' &&
                            <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                <select
                                    className="form-control form-control-user"
                                    onChange={(e) => {
                                        handleInput('meta_data',  e.target.value , 'Meeting_Type', e)
                                    }} required={true}>
                                    <option value="">Select Completing As</option>
                                    <option value="F2F">F2F</option>
                                    <option value="Virtual">Virtual</option>
                                </select>
                                <label className="large-label float-lb">
                                    Meeting Type <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        }
                        {val?.type === 'n15' &&
                            <>
                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                    <select
                                        className="form-control form-control-user"
                                        onChange={(e) => {handleInput('meta_data', e.target.value, val.title.replaceAll(" ", '_'))}}
                                        required={true}
                                    >
                                        <option value="">Select {val?.title}</option>
                                        <option value="Opex">Opex</option>
                                        <option value="Capex">Capex</option>
                                    </select>
                                    <label className="large-label float-lb">
                                        {val.title} <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                    <select
                                        className="form-control form-control-user"
                                        onChange={(e) => {handleInput('meta_data', e.target.value, val.title.replaceAll(" ", '_'))}}
                                        required={true}>
                                        <option value="">Select {val?.title}</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                    <label className="large-label float-lb">
                                        {val.title} <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>
                            </>
                        }
                        {val.type === 'n16' &&
                            <>
                                <div className="col-sm-6 mt-4 d-mtk-1 float-field">
                                    <select
                                        className="form-control form-control-user"
                                        onChange={(e) => {handleInput('meta_data', e.target.value, val.title.replaceAll(" ", '_'))}}
                                        required={true}>
                                        <option value="">Select {val?.title}</option>
                                        <option value="Lost to competitor">Lost to competitor</option>
                                        <option value="Requirement delayed">Requirement delayed</option>
                                        <option value="Not interested ">Not interested </option>
                                    </select>
                                    <label className="large-label float-lb">
                                        {val.title} <i className="bi bi-asterisk astrick-icon"></i>
                                    </label>
                                </div>

                                {inputList[0]['meta_data']['Reason_Of_Drop'] !== undefined && inputList[0]['meta_data']['Reason_Of_Drop'] !== "" &&
                                    inputList[0]['meta_data']['Reason_Of_Drop']  === "Lost to competitor" &&
                                    <>
                                        <div className="col-md-6 float-field ">
                                            <input type="text"
                                                   className="form-control form-control-user"
                                                   placeholder=" "
                                                   onChange={(e) => {handleInput('meta_data', e.target.value, 'Competition_Name')}}
                                                   required
                                            />
                                            <label className="large-label float-lb">
                                                Name of competitor <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                        <div className="col-md-6 float-field ">
                                            <input type="text"
                                                   className="form-control form-control-user"
                                                   placeholder=" "
                                                   onChange={(e) => {handleInput('meta_data', e.target.value, 'Commercials')}}
                                                   required
                                            />
                                            <label className="large-label float-lb">
                                                Commercials <i className="bi bi-asterisk astrick-icon"></i>
                                            </label>
                                        </div>
                                    </>
                                }
                            </>
                        }
                        {val.type === 'n17' &&
                            <div className="col-md-6 float-field ">
                                <input type="text"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {handleInput('meta_data', e.target.value, 'Competition_Quote')}}
                                       required
                                />
                                <label className="large-label float-lb">
                                    Competition Quote <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        }
                        {val?.type === 'n18' &&
                            <div className="col-md-6 float-field ">
                                <input type="number"
                                       className="form-control form-control-user"
                                       placeholder=" "
                                       onChange={(e) => {handleInput('meta_data', e.target.value, 'Waiting_Time')}}
                                       required
                                />
                                <label className="large-label float-lb">
                                    Waiting Time <i className="bi bi-asterisk astrick-icon"></i>
                                </label>
                            </div>
                        }

                        {val?.type === 'n21' &&
                            <>
                                {selectedTaggedAlongResponse?.selected &&
                                    <div className="col-sm-6 mtk-075 float-field mb-4">
                                        <DropDownInput
                                            data={senior}
                                            label={'Tagged along users'}
                                            getIdValue={(val) => {
                                                // setTaggedAlonedReportee(val)
                                            }}
                                            selectedList={selectedTaggedAlongResponse?.selected ?? []}
                                            multipule={true}
                                            disabled={true}
                                        />
                                    </div>
                                }

                                <div className="col-sm-6 mtk-075 float-field mb-4">
                                    <DropDownInput
                                        data={selectedTaggedAlongResponse?.new_tagged_along}
                                        label={'Additional Tag along'}
                                        getIdValue={(val) => {
                                            setTaggedAlonedReportee(val)
                                        }}
                                        multipule={true}
                                    />
                                </div>
                            </>
                        }
                    </>
                )
            })}
        </>
    )
}

export default Type